import { mapState, mapActions } from "vuex";
import { SettingModule } from "./modules/settings.module";
export const layoutComputed = {
    ...mapState("layout", ["layoutType", "leftSidebarType", "layoutWidth", "topbar", "loader"]),
};
export const settingsComputed = {
    ...mapState("settings", ["tenant", "securityRights", "userProfile"]),
};
export const layoutMethods = mapActions("layout", ["ChangeLayoutType", "ChangeLayoutWidth", "ChangeLeftSidebarType", "ChangeTopbar", "ChangeLoaderValue"]);
export const getTenantId = () => {
    var tenantId = localStorage.getItem("tenantId");
    return tenantId !== null || tenantId !== undefined ? tenantId : "";
};
export const hasRight = (rightId) => {
    return SettingModule.userRights.some((x) => x == rightId);
};
export const isTeamLeadCheck = () => {
    return SettingModule.IsAppUserTeamLead();
};
